import { ModalAPI } from '@philips-internal/oswald-ui-components';
import { ModalType } from '@philips-internal/oswald-ui-constants';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isMobile } from '@philips-internal/oswald-ui-utils';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { TermsOfUseType } from '../../constants/terms-of-use-type';
import BaseController from '../BaseController';

@Controller({ component: 'modal-terms-of-use', fragment: 'terms-of-use-modal' })
class TermsOfUseModalController extends BaseController {

  @OnMount({ target: 'modal-terms-of-use' })
  onMountModalTermsUseDetail(event: MountEvent): void {
    const nrSeqTermo = this.getHistoryRouteParam<Value>('nrSeqTermo');
    const termType = this.getHistoryRouteParam<Value>('termType');
    this.context.set({ nrSeqTermo });
    const modal = event.target as ModalAPI;
    switch(termType) {
      case TermsOfUseType.TERM_OF_USE:
        modal.setTitle('patient.terms.use');
        break;
      case TermsOfUseType.TERM_OF_CONSENT:
        modal.setTitle('patient.terms.consent');
        break;
    }
    if(isMobile()) {
      modal.setType(ModalType.FULLSCREEN);
    }
  }

  @OnClose({ target: 'modal-terms-of-use' })
  onClose(): void {
    this.historyService.push(APPLICATION_ROUTES.PROFILE_PRIVACY);
  }

}

export default TermsOfUseModalController;